
window._ = require("lodash");
import Vue from 'vue'
import "./axios"; 
import "./vee-validate";
import "./vuetify";
import "./i18n";
import "./register-service-worker";
 
import GlobalDirectives from './globalDirective';
import Notifications from 'vue-notification'
import VueProgressiveImage from 'vue-progressive-image'
Vue.use(Notifications)
Vue.config.productionTip = false
Vue.use(VueProgressiveImage, {
  delay: 2000
})
Vue.use(GlobalDirectives);

import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)






